import React, { Component } from 'react';

import { Dropdown } from './fields/Dropdown';

export default class DownloadDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnUrl: '',
    };
  }

  componentDidMount() {
    const {
      points,
    } = this.props;
    const firstPointWithUrl = points.find(({ images }) => images?.[0]?.url);

    this.setState({
      btnUrl: firstPointWithUrl.images[0].url,
    });
  }

  optionChange = (value) => {
    this.setState({
      btnUrl: value,
    });
  };

  renderOptions = (points) => {
    const options = points
      .filter((point) => Array.isArray(point.images) && point.images[0])
      .map(({ header, images }) => ({
        label: header,
        value: images[0].url,
      }));

    return (
      <Dropdown
        ariaLabel="Assembly Instruction"
        className="dropdown-container__selection"
        onChange={this.optionChange}
        options={options}
        value={this.state.btnUrl}
      />
    );
  };

  render() {
    const { anchor, points } = this.props;

    return (
      <div id={anchor || undefined} className="dropdown-container">
        <div className="form-fancy-wrapper">
          {this.renderOptions(points)}
          <a
            className={'btn btn-terracotta dropdown-container__download'}
            href={this.state.btnUrl}
            target="_blank" rel="noopener noreferrer"
          >
            Download
          </a>
        </div>
      </div>
    );
  }
}
